<template>
  <div class="report-total-responses">
    <aha-icon-container
      size="md"
      icon-class="bg-primary-60"
    >
      <aha-icon
        name="chat"
        class="text-primary-90 -mt-0.5"
        :class="{'text-secondary-40': isLoadingReport}"
        width="15"
        height="15"
        viewBox="0 0 14 15"
      />
    </aha-icon-container>
    <strong
      class="mr-1"
      :class="{'text-secondary-40': isLoadingReport}"
    >
      Total interactions:
    </strong>
    <span class="response-number">
      <span v-if="!isLoadingReport">
        {{ $func.formatter(totalInteractions, 'KMB') }}
      </span>
      <aha-skeleton-loader
        class="relative -top-0.25"
        width="50px"
        v-else
      />
    </span>
    <span>
      <i
        v-show="!isLoadingReport"
        class="fas fa-question-circle text-secondary-40 cursor-pointer"
        v-tooltip="totalResponsesTooltip"
      />

    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    totalInteractions: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('presentationReport', [
      'isLoadingReport',
    ]),
    totalResponsesTooltip() {
      return {
        content: 'An \'interaction\' is any of these actions from a participant:<br/> - A reaction<br/> - A Q&A question<br/> - A submitted response.',
        classes: 'total-responses-tooltip',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .report-total-responses {
    @apply flex flex-row items-center w-full;
    .response-number {
      @apply font-bold text-primary-90 mr-1.5;
    }
    .total-responses-tooltip {
      max-width: 240px;
    }
  }
</style>
